<template>
  <div class="tabbar">
    <div 
      v-for="item in tabList" 
      :class="activeIndex == item.id ? 'active' : ''" 
      @click="changeTab(item)"
    >
      {{item.title}}
    </div>
  </div>
</template>
<script>
export default {
    name: 'TopTabBar',
    props: {
      tabList: {
        type: Array,
        default() {
            return []
        },
      },
    },
    data() {
      return {
        activeIndex: 0,
      };
    },
    methods: {
      changeTab(item) {
        this.activeIndex = item.id
        this.$emit('change', item.id)
      },
    },
}
</script>
<style lang="scss" scoped>
.tabbar{
  width: 100%;
  background-color: #fff;
  padding: 0;
  color: #868686;
  position: relative;
  z-index: 5;
  >div{
    background-color: #fff;
    border-bottom: 2px solid #fff;
    color: #868686;
    font-size: 28px;
    &.active {
      border-color: #2E94E5;
      background-color: #fff;
      color: #2E94E5;
    }
    &:first-child{
       border-radius: 0;
    }
    &:last-child{
       border-radius: 0;
    }
  }
}
</style>